import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth";
import { UnratedPill } from "./UnratedPill";

// NavLink already sets aria-current="page" on the active link by default —
// we just need to keep the visual "active" class in sync. Screen reader
// users get the landmark + aria-current behavior for free.

export function Layout() {
  const { user, signOut, authDisabled } = useAuth();
  return (
    <>
      <nav className="nav" aria-label="Primary">
        <strong>RoastMCP</strong>
        <NavLink
          to="/"
          end
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          Roasts
        </NavLink>
        <UnratedPill />
        <NavLink
          to="/coffees"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          Coffees
        </NavLink>
        <NavLink
          to="/maintenance"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          Maintenance
        </NavLink>
        <NavLink
          to="/ingestion"
          className={({ isActive }) => (isActive ? "active" : undefined)}
        >
          Ingestion
        </NavLink>
        <span className="spacer" />
        {authDisabled ? (
          <span
            className="badge warn"
            title="VITE_AUTH_DISABLED is set — talking to a local roast serve with auth off"
          >
            local · no auth
          </span>
        ) : (
          <>
            <span className="who">{user?.email ?? ""}</span>
            <button className="secondary" onClick={() => void signOut()}>
              Sign out
            </button>
          </>
        )}
      </nav>
      <main className="container">
        <Outlet />
      </main>
    </>
  );
}
